import { useNavigate, useParams } from 'react-router-dom'
import { SyntheticEvent, useEffect, useState } from 'react'
import axiosClient from 'axios-client'
import { Role, Status, User } from 'types'
import style from 'assets/css/Form.module.css'

export default function UserForm() {
  const navigate = useNavigate()
  let { id } = useParams()
  const [user, setUser] = useState<User>({} as User)
  const [loading, setLoading] = useState(false)

  const roles = Object.values(Role)
  const statusVal = Object.values(Status)

  useEffect(() => {
    if (id) {
      setLoading(true)
      axiosClient
        .get(`/users/${id}`)
        .then(({ data }) => {
          setLoading(false)
          setUser({ ...data })
        })
        .catch(() => {
          setLoading(false)
        })
    }
  }, [])

  const onSubmit = (ev: SyntheticEvent) => {
    ev.preventDefault()

    if (user.id) {
      axiosClient
        .put(`/users/${user.id}`, user)
    } else {
      axiosClient
        .post('/users', user)
        .then(() => {
          // TODO navigate to /users/:id
        })
    }
  }

  return (
    <>
      <form
        className={`${style.form}`}
        onSubmit={onSubmit}
        style={{ width: '50%', margin: 'auto' }}
      >
        <div className={`${style.title}`}>
          {user.id ? `Update User: ${user.firstname} ${user.lastname} ` : 'New User'}
        </div>
        <div className={`${style.container}`}>
          <div className={`${style.input_container}`}>
            <label
              className={`${style.label}`}
              htmlFor="first"
            >
              First name *
            </label>
            <input
              className={`${style.input}`}
              type="text"
              name="first"
              id="first"
              value={user.firstname}
              onChange={ev => setUser({ ...user, firstname: ev.target.value })}
              required
            />
          </div>
          <div className={`${style.input_container}`}>
            <label
              className={`${style.label}`}
              htmlFor="last"
            >
              Last name *
            </label>
            <input
              className={`${style.input}`}
              type="text"
              name="last"
              id="last"
              value={user.lastname}
              onChange={ev => setUser({ ...user, lastname: ev.target.value })}
            />
          </div>

          <div className={`${style.input_container} ${style.span2}`}>
            <label
              className={`${style.label}`}
              htmlFor="email"
            >
              Email *
            </label>
            <input
              className={`${style.input}`}
              type="email"
              name="email"
              id="email"
              value={user.email}
              onChange={ev => setUser({ ...user, email: ev.target.value })}
              required
            />
          </div>

          <div className={`${style.input_container} ${style.span2}`}>
            <label
              className={`${style.label}`}
              htmlFor="role"
            >
              Role *
            </label>
            <select
              name="role"
              id="role"
              value={user.roles? user.roles[0] : 0}
              onChange={ev => setUser({ ...user, roles: [ev.target.value] as Role[] })}
              required
            >
              <option value={''}>Select a role</option>
              {roles.map(option => (
                <option
                  key={option}
                  value={option}
                >
                  {option}
                </option>
              ))}
            </select>
          </div>

          <div className={`${style.input_container} ${style.span2}`}>
            <label
              className={`${style.label}`}
              htmlFor="status"
            >
              Status *
            </label>
            <select
              name="status"
              id="status"
              value={user.status}
              onChange={ev => setUser({ ...user, status: ev.target.value as Status })}
              required
            >
              <option value={''}>Select a status</option>
              {statusVal.map(option => (
                <option
                  key={option}
                  value={option}
                >
                  {option}
                </option>
              ))}
            </select>
          </div>
        </div>
        <button
          type="submit"
          className={`${style.button} ${style.submit}`}
          style={{ width: '30%' }}
        >
          Save
        </button>
        <button
          type="reset"
          className={`${style.button} ${style.cancel}`}
          style={{ width: '30%' }}
          onClick={() => navigate(-1)}
        >
          Cancel
        </button>
      </form>
    </>
  )
}
